import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react';
import { PurchaseOrderOutline } from '@/hooks/api/models';
import { ModalConfirm } from '@/components/element/modal/ModalConfirm';
import { PurchaseOrderOutlineLogic } from '@/hooks/api/models/logics';
import { useCurrentPurchaseOrder } from '@/providers/PurchaseOrderProvider';
import { useInvalidatePrevPurchaseOrders, usePrevPurchaseOrders } from '@/hooks/api/0571_prev_purchase_orders';
import { useDestroyPrevPurchaseOrder } from '@/hooks/api/2670_destroy_prev_purchase_order';
import { useInvalidateTargetPrevPurchaseOrders } from '@/hooks/api/0574_target_prev_purchase_orders';

export const PrevPurchaseOrdersElement = () => {
  const { setShowLoading } = useLoading();
  const { _w_, _t_ } = useCurrentTeamMember();
  const { _po_ } = useCurrentPurchaseOrder();
  const orderParams = { identifier: _w_!.identifier, team_id: _t_!.id, id: _po_!.id };
  const { data: prevOrders } = usePrevPurchaseOrders(orderParams);
  const { mutate, isSuccess, isPending } = useDestroyPrevPurchaseOrder();
  const { invalidate: invalidatePrevOrders } = useInvalidatePrevPurchaseOrders(orderParams);
  const { invalidate: invalidateTargetPrevOrders } = useInvalidateTargetPrevPurchaseOrders(orderParams);
  const [delTarget, setDelTarget] = useState<PurchaseOrderOutline>();

  useEffect(() => {
    if (isSuccess) {
      invalidatePrevOrders();
      invalidateTargetPrevOrders();
    }
  }, [isSuccess]);

  useEffect(() => setShowLoading(isPending), [isPending]);

  const onDeleteClick = () => {
    setShowLoading(true);
    mutate({ identifier: _w_!.identifier, team_id: _t_!.id, purchase_order_id: _po_!.id, id: delTarget!.id });
  };

  if (prevOrders == null || prevOrders.length === 0) return null;

  return (
    <>
      <hr className="horizontal dark my-3" />

      <div className="table-responsive">
        <ModalConfirm
          modalId={`delConfirm`}
          okClicked={() => onDeleteClick()}
          message={'削除します。よろしいですか？'}
        />

        <table className="table align-items-center">
          <thead>
            <tr>
              <th className="text-secondary text-xxs font-weight-bolder opacity-7 px-2">以前のプロジェクト</th>
              <th className="text-secondary text-xxs font-weight-bold opacity-7 px-2" style={{ width: 60 }}></th>
            </tr>
          </thead>
          <tbody>
            {prevOrders?.map((d) => (
              <PrevPurchaseOrderRow key={`prev-order-${d.id}`} d={d} setDelTarget={setDelTarget} />
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

type Props = {
  d: PurchaseOrderOutline;
  setDelTarget: Dispatch<SetStateAction<PurchaseOrderOutline | undefined>>;
};
const PrevPurchaseOrderRow = ({ d, setDelTarget }: Props) => {
  const orderLabel = useMemo(() => {
    return PurchaseOrderOutlineLogic.toLabel(d);
  }, [d]);

  return (
    <tr>
      <td className="font-weight-bold text-sm text-dark mb-1">{orderLabel}</td>
      <td>
        <button
          className="btn btn-icon-only bg-gradient-danger"
          data-bs-toggle="modal"
          data-bs-target={`#delConfirm`}
          onClick={() => setDelTarget(d)}
        >
          <i className="fas fa-trash-alt"></i>
        </button>
      </td>
    </tr>
  );
};
